interface IShoppingBagProps {
  style?: React.CSSProperties;
  color?: string;
  size?: number;
}

const ShoppingBag = ({ style, size = 20, color = 'black' }: IShoppingBagProps) => {
  return (
    <div style={style}>
      <svg
        width="16"
        height={size}
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.99627 5.75H13.0037C13.6572 5.75 14.2005 6.2534 14.2501 6.90504L15.0882 17.905C15.1435 18.6307 14.5696 19.25 13.8418 19.25H2.15818C1.4304 19.25 0.856501 18.6307 0.91179 17.905L1.74989 6.90503C1.79953 6.2534 2.34275 5.75 2.99627 5.75Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M5.00208 8C4.50557 6.5 5.09003 1 8.00208 1C11.0021 0.999999 11.5021 5.5 11.0021 8"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ShoppingBag;
